import { postDataAPI } from "../../../services/apiWrapper";
import { errorAlert, successAlert } from "../../../utils/alert";

/*
 * Bulk upload, council side. The rows have already been read out of the file
 * in the browser; this only posts them.
 */

const adminToken = () => localStorage.getItem("adminToken");

const ENDPOINT = {
  questions: "admin/bulk/questions",
  assignment: "admin/bulk/assignment-marks",
  result: "admin/bulk/result-marks",
};

/**
 * @param {"questions"|"assignment"|"result"} kind
 * @param {object[]} rows
 * @param {boolean} dryRun  true to check the file without writing anything
 * @param {object} extra    anything the screen has chosen rather than the
 *                          file - for questions, the subject_id picked from
 *                          the trade / sub trade / course / subject boxes
 */
export const uploadRows = (kind, rows, dryRun, extra = {}) => async (dispatch) => {
  try {
    const response = await dispatch(
      postDataAPI(
        ENDPOINT[kind],
        { rows, dry_run: dryRun ? 1 : 0, ...extra },
        adminToken()
      )
    );

    if (response) {
      if (!dryRun) {
        successAlert(response.data.message);
      }
      return response.data.data;
    }
    return false;
  } catch (error) {
    errorAlert(
      error.response?.data?.message || "The file could not be uploaded."
    );
    return false;
  }
};
